import moment from "moment";

export function formatDateWithAmPm(timestamp, monthLength = "full") {
  if (!timestamp) return "-";
  const date = moment.utc(timestamp);
  const browserTimezoneDate = date.clone().local();
  const monthFormat = monthLength === "short" ? "MMM" : "MMMM";
  const formattedDate = browserTimezoneDate.format(`${monthFormat} Do YYYY, h:mm a`);

  return formattedDate;
}
